import { UserRole } from '../enums';

export function resolveSignupRole(requestedRole?: UserRole): UserRole {
  return requestedRole === UserRole.CREATOR ? UserRole.CREATOR : UserRole.CONSUMER;
}
